import { basicDataset } from '@mono/types/src/mds';
import { Expression } from 'mapbox-gl';

export const sourceId = 'mov://basic-datasets';

export const renderLayer = {
    id: sourceId,
    type: 'circle' as const,
    source: sourceId,
    interactive: true,
    paint: {
        'circle-radius': [
            //
            'case',
            ['boolean', ['feature-state', 'hover'], false],
            12,
            8,
            //
        ] as Expression,
        'circle-color': [
            //
            'case',
            ['boolean', ['feature-state', 'isSelected'], false],
            '#857dff',
            '#666',
            //
        ] as Expression,
        'circle-stroke-color': '#999',
        'circle-stroke-width': 1,
    },
};
export const hoverLayer = {
    id: sourceId + '-hover',
    type: 'circle' as const,
    source: sourceId,
    interactive: true,
    paint: {
        'circle-radius': 16,
        'circle-color': 'rgba(0, 0, 0, 0)',
    },
};

export const selectedLayer = {
    id: sourceId + '-selected',
    type: 'circle' as const,
    source: sourceId,
    interactive: true,
    paint: {
        'circle-radius': [
            //
            'case',
            ['boolean', ['feature-state', 'isSelected'], false],
            12,
            ['boolean', ['feature-state', 'isConsidering'], false],
            12,
            0,
            //
        ] as Expression,
        'circle-color': '#857dff',
        'circle-stroke-color': '#999',
        'circle-stroke-width': [
            //
            'case',
            ['boolean', ['feature-state', 'isSelected'], false],
            1,
            ['boolean', ['feature-state', 'isConsidering'], false],
            1,
            0,
            //
        ] as Expression,
    },
};

export const generateSource = (datasets: basicDataset[]) => {
    const obsDatasets = datasets.filter(isDatasetAPoint);
    return {
        type: 'FeatureCollection' as const,
        features: obsDatasets
            .map((dataset) => {
                const latlon = datasetToPoint(dataset);
                if (!latlon) return null;
                return {
                    type: 'Feature' as const,
                    id: dataset.id,
                    properties: {
                        id: dataset.id,
                    },
                    geometry: {
                        type: 'Point' as const,
                        coordinates: latlon,
                    },
                };
            })
            .filter((f): f is NonNullable<typeof f> => !!f),
    };
};
export const datasetToPoint = (basicDataset: basicDataset) => {
    if (!isDatasetAPoint(basicDataset)) return null;
    return basicDataset.spatial_boundary.replace('SRID=4326;POINT(', '').slice(0, -1).split(' ').map(Number) as [number, number];
};

export const isDatasetAPoint = (dataset: basicDataset) => {
    return dataset.spatial_boundary.startsWith('SRID=4326;');
};
